<template>
  <v-col cols="12">
    <v-card color="kbWhite">
      <v-card-title>
        {{$t('general.attendedConversations')}}
      </v-card-title>
      <v-card-text>
        <canvas id="canvas-attended"></canvas>
      </v-card-text>
    </v-card>
  </v-col>
</template>

<script>
import { mapState } from 'vuex'
import colorsChart from '@/libs/colorsChart.js'

export default {
  computed: {
    ...mapState({
      statistics: state => state.conversations.statistics
    }),
    info () {
      return {
        labels: [],
        datasets: [
          {
            backgroundColor: colorsChart.green,
            borderColor: colorsChart.green,
            data: [],
            fill: false,
            label: this.$t('general.attended')
          },
          {
            backgroundColor: colorsChart.red,
            borderColor: colorsChart.red,
            data: [],
            fill: false,
            label: this.$t('general.noAttended')
          }
        ]
      }
    },
    language () {
      return this.$i18n.locale
    }
  },
  data: () => ({
    chart: null
  }),
  methods: {
    renderChart () {
      this.setData()
        let ctx = document.getElementById('canvas-attended').getContext('2d') // eslint-disable-line
        this.chart = new Chart(ctx, { // eslint-disable-line
        type: 'line',
        data: this.info,
        options: {
          tooltips: {
            mode: 'index',
            intersect: false
          },
          stacked: false,
          responsive: true,
          scales: {
            xAxes: [{
              scaleLabel: {
                display: true,
                labelString: this.$t('general.date')
              }
            }],
            yAxes: [
              {
                scaleLabel: {
                  display: true,
                  labelString: this.$('general.conversationsNumber')
                },
                type: 'linear', // only linear but allow scale type registration. This allows extensions to exist solely for log scale for instance
                display: true,
                position: 'left'
              }]
          }
        }
      })
    },
    setData () {
      if (!this.statistics) return {}

      const attendedByDay = this.statistics.AttendedByDay.concat().sort((a, b) => {
        const aa = parseInt(a.Day.replace(/\-/gi, '')) // eslint-disable-line
        const bb = parseInt(b.Day.replace(/\-/gi, '')) // eslint-disable-line

        return aa - bb
      })

      const map = new Map()
      attendedByDay.forEach((item) => {
        const key = item.Day
        const collection = map.get(key)
        if (!collection) {
          map.set(key, [item])
        } else {
          collection.push(item)
        }
      })

      this.info.labels = []
      this.info.datasets[0].data = []
      this.info.datasets[1].data = []

      map.forEach((value, key) => {
        this.info.labels.push(key)
        const attended = value.find(item => item.Type === 'Attended')
        const notAttended = value.find(item => item.Type === 'NotAttended')

        this.info.datasets[0].data.push(attended ? attended.Count : 0)
        this.info.datasets[1].data.push(notAttended ? notAttended.Count : 0)
      })
    },
    updateChart () {
      this.setData()
      this.chart.update()
    }
  },
  watch: {
    statistics (value) {
      if (!value) return

      if (this.chart) {
        this.updateChart()
      } else {
        this.renderChart()
      }
    },
    language () {
      this.renderChart()
    }
  }
}
</script>
